<template>
  <div class="section-three-container">
    <!-- <div class="carrier carrier-1"></div>
    <div class="carrier carrier-2"></div>
    <div class="carrier carrier-3"></div>
    <div class="carrier carrier-4"></div> -->
    <img v-if="signatureData" :src="signatureData" alt="signature" class="my-signature">
    <!-- <div class="signin" @click="openSignDialog">请签名</div> -->

    <div class="shadow" v-show="signatureDialogShow"></div>
    <div class="signature-dialog" v-show="signatureDialogShow">
      <div class="signature-pad">
        <VueSignaturePad
          width="100%"
          height="100%"
          ref="signaturePad"
          :options="{penColor: '#c69c72', minWidth: 4, maxWidth: 6}"
        />
        <div class="sign-tip"></div>
        <div class="button-group">
          <div class="my-button button-1" @click="clearSignature"></div>
          <div class="my-button button-2" @click="saveSignature"></div>
        </div>
      </div>
    </div>
    <div class="warm-tip" v-show="signatureDialogShow">请放平并旋转你的手机进行签名</div>

    <!-- 底部两按钮 -->
    <div class="operation-group">
      <div class="operation operation-1" @click="$emit('slidePrev')"></div>
      <div class="operation operation-2" @click="openSignDialog"></div>
      <div class="operation operation-3" @click="$emit('slideNext')"></div>
    </div>

    <!-- 记者 -->
    <div class="reporter"></div>
  </div>
</template>

<script>
import anime from 'animejs';

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    }
  },
  components: {
  },
  data() {
    return {
      signatureDialogShow: false,
      signatureData: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  watch: {
    isActive(newVal) {
      if (!newVal) {
        this.leaveAnimation();
      } else {
        this.enterAnimation();
      }
    }
  },
  methods: {
    init() {
      this.fetchComments();
    },
    async fetchComments() {
      this.$emit("mounted");
    },
    openSignDialog() {
      this.signatureDialogShow = true;
      this.resizeCanvas();
    },
    resizeCanvas() {
      this.$nextTick(() => {
        this.$refs.signaturePad.resizeCanvas();
      });
    },
    // 清除签名
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    // 保存签名
    saveSignature() {
      this.signatureDialogShow = false;
      const { data } = this.$refs.signaturePad.saveSignature();
      // if (isEmpty) return;
      this.signatureData = data;
    },

    // 进入本页
    enterAnimation() {
      this.$nextTick(() => {
        this.$refs.signaturePad.resizeCanvas();
      });
      anime({
        targets: '.section-three-container .reporter',
        opacity: [.3, .6, 1],
        translateY: ['100%', '0%'],
        duration: 1800,
        delay: 200,
      });
    },
    // 离开本页
    leaveAnimation() {
    }
  }
};
</script>

<style lang="scss" scoped>
.section-three-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(~@/assets/three/bg.png) center center / 100% 100% no-repeat;
  overflow: hidden;
}

// .carrier {
//   position: absolute;
//   width: 18px;
//   height: 23px;
//   background: url(~@/assets/three/carrier.png) center center / 100% 100%
//     no-repeat;
// }
// .carrier-1 {
//   top: 20px;
//   left: 20px;
//   transform: rotateY(180deg);
// }
// .carrier-2 {
//   top: 20px;
//   right: 20px;
// }
// .carrier-3 {
//   bottom: 20px;
//   left: 20px;
//   transform: rotateY(180deg) rotateX(180deg);
// }
// .carrier-4 {
//   bottom: 20px;
//   right: 20px;
//   transform: rotateX(180deg);
// }

// 我的签名
.my-signature {
  position: absolute;
  left: 50%;
  top: 25%;
  width: 65px;
  height: 100px;
  transform: rotateZ(-90deg);
  margin: 0 auto;
}
// .signin {
//   position: absolute;
//   bottom: 102px;
//   left: 50%;
//   transform: translate(-50%, 0);
//   width: 291px;
//   height: 71px;
//   line-height: 71px;
//   background: url(~@/assets/three/signin.png) center center / 100% 100%
//     no-repeat;
//   color: #b68656;
//   font-size: 18px;
//   text-align: center;
// }
// 底部两按钮
.operation-group {
  z-index: 99;
  position: absolute;
  left: 50%;
  bottom: 49px;
  transform: translate(-50%, 0);
  display: flex;
  .operation {
    width: 115px;
    height: 43px;
    cursor: pointer;
  }
  .operation-1 {
    background: url(~@/assets/to_prev.png) center center / 100% 100% no-repeat;
  }
  .operation-2 {
    margin-left: 9px;
    background: url(~@/assets/three/to_sign.png) center center / 100% 100% no-repeat;
  }
  .operation-3 {
    margin-left: 9px;
    background: url(~@/assets/three/to_next.png) center center / 100% 100% no-repeat;
  }
}
// 记者
.reporter {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 34.562841%;
  background: url(~@/assets/three/reporter.png) center center / 100% 100% no-repeat;
}

// 签名对话框
.shadow {
  z-index: 9999;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: .5;
}
.signature-dialog {
  z-index: 10000;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 325px;
  height: 500px;
  box-sizing: border-box;
  transform: translate(-50%, -50%);
  background: url(~@/assets/three/signature_pad.png) center center / 100% 100%
        no-repeat;
  box-shadow: 0 0 2px #eeeeee;
  border-radius: 6px;
  .signature-pad {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .sign-tip {
    z-index: 0;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 46px;
    height: 122px;
    background: url(~@/assets/three/sign_tip.png) center center / 100% 100%
          no-repeat;
  }
  .button-group {
    position: absolute;
    left: 10px;
    bottom: 10px;
    width: 40px;
    .my-button {
      width: 40px;
      height: 104px;
      font-size: 14px;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
    }
    .button-1 {
      background: url(~@/assets/three/resign.png) center center / 100% 100%
        no-repeat;
    }
    .button-2 {
      margin-top: 10px;
        background: url(~@/assets/three/signed.png) center center / 100% 100%
          no-repeat;
    }
  }
}

.warm-tip {
  z-index: 10000;
  position: absolute;
  left: 50%;
  bottom: 1%;
  width: 210px;
  margin-left: -105px;
  text-align: center;
  animation: flash 1s infinite alternate-reverse linear;
  font-size: 14px;
  color: #ffffff;
  @keyframes flash {
    0% {
      opacity: 1;
    }
    100% {
      opacity: .3;
    }
  }
}
</style>